import { toast } from 'sonner';
import { DallasSnackbarPayload } from './DallasSnackbarPayload';
import DallasSnackbar from './DallasSnackbar';

export function openSnackbar({
  action,
  onDismiss,
  autoDismiss,
  ...props
}: DallasSnackbarPayload) {
  toast.custom((toastId) => (
    <DallasSnackbar
      action={
        action
          ? {
              ...action,
              onClick: () => {
                action.onClick?.();
                toast.dismiss(toastId);
              },
            }
          : undefined
      }
      onDismiss={
        onDismiss || autoDismiss
          ? () => {
              onDismiss?.();
              toast.dismiss(toastId);
            }
          : undefined
      }
      autoDismiss={autoDismiss}
      {...props}
    />
  ));
}
